// segmentViewAspectRatio — pure helper for the aspect ratio the per-Segment
// wallpaper cropper locks to.
//
// The ImageCropper crops to the shape of the open-Segment panel, so the cropped
// image fills it without letterboxing. The panel's box is
//   width  = max(354px, 25vw)      (SegmentView styles: min-width 354px / width 25vw)
//   height = min(900px, 85dvh)     (max-height 900px / height 85dvh)
// which means the target ratio is a function of the CURRENT viewport, not a
// constant — and the viewport changes while the builder is open.

export const SEGMENT_VIEW_MIN_WIDTH_PX = 354;
export const SEGMENT_VIEW_WIDTH_VW = 0.25;
export const SEGMENT_VIEW_MAX_HEIGHT_PX = 900;
export const SEGMENT_VIEW_HEIGHT_VH = 0.85;

/**
 * The open-Segment panel's width/height ratio for a given viewport.
 *
 * @param {number} innerWidth  viewport width in px
 * @param {number} innerHeight viewport height in px
 * @returns {number} width / height (always finite and > 0)
 */
export const computeSegmentViewAspectRatio = (innerWidth, innerHeight) => {
  const w = Number(innerWidth);
  const h = Number(innerHeight);
  const width = Math.max(
    SEGMENT_VIEW_MIN_WIDTH_PX,
    Number.isFinite(w) && w > 0 ? w * SEGMENT_VIEW_WIDTH_VW : 0
  );
  const height = Math.min(
    SEGMENT_VIEW_MAX_HEIGHT_PX,
    Number.isFinite(h) && h > 0 ? h * SEGMENT_VIEW_HEIGHT_VH : SEGMENT_VIEW_MAX_HEIGHT_PX
  );
  // height can only reach 0 if the viewport reports 0 (jsdom / a hidden tab);
  // fall back to the max-height box rather than emitting Infinity/NaN.
  const safeHeight = height > 0 ? height : SEGMENT_VIEW_MAX_HEIGHT_PX;
  return width / safeHeight;
};
